module.exports = __webpack_public_path__ + "assets/images/sizeofOffice-02.e589ae76365ab61713e78adf913034e6.svg";